export default "__VITE_ASSET__BmpyDjS4__"